import { connect } from 'react-redux';
import QuoteForm from '../QuoteForm';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Ihistory } from '../../../models';
import { getSecurityUsers } from '../../../actions/manageUserActions';
import { manageQuoteQueryParamsEnum } from '../manageQuotes';
import {
    toggleQuotesModal,
    toggleQuotesDetailsModal,
    updateSelectedQuote,
    saveQuoteFiles,
    updateQuoteStatus
} from '../../../actions/manageCustomerQuotesActions';
import { initialFacility } from '../../../reducers/initialState';
import { selectIsLoading } from '../../../reducers/commonReducers';
import { IinitialState } from '../../../reducers';
import { getCloudDocument } from '../../../actions/manageDocumentActions';
import { WithCommonMobileModal } from '../../common/mobile/WithCommonMobileModal';

type Iprops = {
    colorButton: string;
    queryParams: typeof manageQuoteQueryParamsEnum;
    history: Ihistory;
};

const mapStateToProps = (
    state: IinitialState,
    ownProps: Iprops & WithTranslation
) => {
    const { selectedQuote } = state.manageCustomerQuotes;
    const facility = selectedQuote.facilityID
        ? state.facilities[selectedQuote.facilityID]
        : initialFacility;

    return {
        show: state.manageCustomerQuotes.showEditQuoteModal,
        loading: selectIsLoading(state),
        selectedQuote,
        originalQuote:
            state.manageCustomerQuotes.quotesByID[
                ownProps.queryParams.selectedQuoteID
            ],
        className: 'facility-contact-edit',
        title: ownProps.t('editCustomerQuoteForm.modalTitle'),
        facility
    };
};

export default withTranslation('manageQuotes')(
    connect(mapStateToProps, {
        onCancel: toggleQuotesModal,
        onHide: toggleQuotesModal,
        toggleModal: toggleQuotesModal,
        onChange: updateSelectedQuote,
        onSubmit: updateQuoteStatus,
        toggleQuotesDetailsModal,
        getSecurityUsers,
        getCloudDocument,
        saveQuoteFiles
    })(WithCommonMobileModal(QuoteForm))
);
